import Vue from 'vue'
import Toasted from 'vue-toasted'

Vue.use(Toasted, {
  duration: 4000, //tiempo en ms
  position: 'bottom-center',
})
